import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { Input } from '@progress/kendo-react-inputs';
import { GearFieldWrapper } from '../GearFieldWrapper';

interface FormInputFieldProps extends FieldRenderProps {
  min?: number;
  max?: number;
}

export const FormInput: React.FC<FormInputFieldProps> = fieldRenderProps => {
  const { min, max, disabled, ...restProps } = fieldRenderProps;
  return (
    <GearFieldWrapper {...restProps}>
      <Input
        name={restProps.name}
        valid={restProps.valid}
        value={restProps.value}
        defaultValue={restProps.defaultValue}
        onChange={restProps.onChange}
        label={undefined}
        labelClassName={restProps.labelClassName}
        validationMessage={restProps.validationMessage || undefined}
        minLength={min}
        maxLength={max}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
